// src/api/memeApi.ts
import { MemeTemplate } from '../types';
import { useConfig } from '../hooks/useConfig';
import { useCallback } from 'react';

// Hook to get API endpoints
export function useMemeApi() {
    const config = useConfig();

    // Use useCallback to memoize the function reference
    const fetchMemeTemplates = useCallback(async (): Promise<MemeTemplate[]> => {
        try {
            const url = `${config.API_BASE_URL}/data/meme_data.json`;
            console.log(`Fetching meme templates from: ${url}`);

            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`Failed to fetch meme templates: ${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            // Map the API data to our application's format
            return data.map((item: any) => ({
                id: item.template_id,
                name: item.title,
                imageUrl: `${config.API_BASE_URL}/memes/${item.template_id}.${item.format}`,
                tags: item.tags || [],
                width: item.width,
                height: item.height
            }));
        } catch (error) {
            console.error('Error fetching meme templates:', error);

            // For development, we can include a fallback set of templates
            return getLocalTemplates();
        }
    }, [config.API_BASE_URL]); // Only recreate when API_BASE_URL changes

    // Generate a meme image URL (also memoized)
    const getMemeImageUrl = useCallback((templateId: string, format: string = 'jpg'): string => {
        return `${config.API_BASE_URL}/memes/${templateId}.${format}`;
    }, [config.API_BASE_URL]);

    return {
        fetchMemeTemplates,
        getMemeImageUrl
    };
}

// Fallback templates for development
const getLocalTemplates = (): MemeTemplate[] => {
    return [
        {
            "id": "181913649",
            "name": "Drake Hotline Bling",
            "imageUrl": "https://i.imgflip.com/30b1gx.jpg",
            "tags": ["drake", "reaction", "popular", "comparison"],
            "width": 1200,
            "height": 1200
        },
        {
            "id": "87743020",
            "name": "Two Buttons",
            "imageUrl": "https://i.imgflip.com/1g8my4.jpg",
            "tags": ["buttons", "choice", "decision", "popular"],
            "width": 600,
            "height": 908
        },
        // Add more fallback templates as needed
    ];
};